import { Navigate } from 'react-router-dom';
import OtpForm from '../../components/auth/otp/otp-form';
import { RootState, useTypedSelector } from '../../store';

export default function Otp() {
    /* We would like avoid to set otp if not required */
    const auth = useTypedSelector((state: RootState) => state.auth);
    const isOTPRequired: boolean = auth.isOtpRequired;

    // is required an otp code to finish the login process
    if (!isOTPRequired) {
        return <Navigate to="/login" />;
    }

    return <OtpForm />;
}
